import React from 'react';
import {
  injectIntl,
  WrappedComponentProps,
  FormattedMessage
} from '@kyruus/intl';
import { ProviderMatchProviderV9 } from '@kyruus/types';

import messages from '../../lib/messages';
import { isUrlYouTube } from '../../lib/utils';
import CardContainer from '../CardContainer/card-container';
import VideoComponent from './video-component';
import YouTubeVideoComponent from './youtube-video-component';

import { VideoWrapper, VideoSectionHeader } from './styles';

import { withErrorBoundary } from '../ErrorFallback/with-error-boundary';

interface ProviderVideoProps {
  provider: ProviderMatchProviderV9;
}

const ProviderVideo = ({
  intl,
  provider
}: ProviderVideoProps & WrappedComponentProps): React.ReactElement => {
  const { video_url } = provider;

  const videoComponentProps = {
    url: video_url,
    accessibilityText: intl.formatMessage(messages.ariavideo),
    iframeId: 'main-provider-video',
    containerClass: 'video-wrapper'
  };

  return (
    <VideoWrapper>
      <CardContainer>
        <VideoSectionHeader>
          <FormattedMessage {...messages.videoHeader} />
        </VideoSectionHeader>
        {isUrlYouTube(video_url) ? (
          <YouTubeVideoComponent {...videoComponentProps} />
        ) : (
          <VideoComponent {...videoComponentProps} />
        )}
      </CardContainer>
    </VideoWrapper>
  );
};

export default withErrorBoundary(injectIntl(ProviderVideo));
